import { ReactComponent as IconUserEdit } from "assets/svg/20-Avatar2.svg";
import { ReactComponent as IconChartLine } from "assets/svg/20-chart-line.svg";
import { ReactComponent as IconInbox } from "assets/svg/20-inbox.svg";
import { ReactComponent as IconLogOut } from "assets/svg/20-log-out.svg";
import { ReactComponent as IconHome } from "assets/svg/home.svg";
import { ReactComponent as IconTree } from "assets/svg/tree.svg";
import { ReactComponent as IconViewTable } from "assets/svg/view_table.svg";
import { ReactComponent as IconUserPlus } from "assets/svg/20-user-plus.svg";

import { SCREEN } from "helper/roleChecker/Screens";
import pathRoutes from "routes/pathRoutes";

export enum VALUE_SIDE_NAV_PARENTS {
  VIEW = "VIEW",
  HOMEPAGE = "HOMEPAGE", // Trang chủ
  INFORMATION = "INFORMATION", // Thông tin nhân sự
  PERSONNEL_INFOMATION = "PERSONNEL_INFOMATION", // Thông tin cá nhân
  OPERATION_PROCESS = "OPERATION_PROCESS", // Quá trình công tác hợp dồng
  WORK_PERFORMANCE = "WORK_PERFORMANCE", // Kết quả thực hiện công việc
  DECLARE_LEAVE = "DECLARE_LEAVE", // Khai báo nghỉ
  PERSONNEL_FORM = "PERSONNEL_FORM", // Mẫu biểu nhân sự
  REGULATIONS = "REGULATIONS", // Quy định
  INTERNAL_CULTURE = "INTERNAL_CULTURE", // Văn hóa nội bộ
  INTERNAL = "INTERNAL", // Bản tin nội bộ,
  INTERNAL_NEWS = "INTERNAL_NEWS", // Bản tin
  INTERNAL_EVENT = "INTERNAL_EVENT", // Sự kiện
  INTERNAL_BIRTHDAY = "INTERNAL_BIRTHDAY", // Sinh nhật
  RESEARCH_REPORT = "RESEARCH_REPORT",
  DOCUMENTS = "DOCUMENTS", // Thư viện văn bản
  INTERNAL_DOCUMENT = "INTERNAL_DOCUMENT", // Văn bản nội bộ
  AUTHORIZATION_DOCUMENT = "AUTHORIZATION_DOCUMENT", // Văn bản phân cấp ủy quyền
  RECRUITMENT = "RECRUITMENT", // Tuyển dụng
  LOG_OUT = "LOG_OUT",
  RECRUITMENT_REQUIREMENT = "RECRUITMENT_REQUIREMENT", // Tuyển dụng
  RECRUITMENT_EVALUATION = "RECRUITMENT_EVALUATION", // Đánh giá ứng viên
  MBS_2026 = "MBS_2026", // MBS 2026
}

export interface NavGroupData {
  value: VALUE_SIDE_NAV_PARENTS;
  label: string;
  icon: JSX.Element;
  navSubList?: NavSubItemData[];
  path?: string;
  subLabel?: string;
  subValue?: string;
  roleSide?: string;
  screenKey?: string | string[];
  parameter?: string;
}

export interface NavSubItemData {
  path: string;
  subLabel: string;
  subValue: string;
  parameter: string;
  screenKey?: string;
}

export const sidenavData: NavGroupData[] = [
  {
    value: VALUE_SIDE_NAV_PARENTS.HOMEPAGE,
    label: "Trang chủ",
    icon: <IconHome />,
    path: pathRoutes.homepage,
    parameter: pathRoutes.homepage,
    screenKey: SCREEN.IP_001,
  },
  {
    value: VALUE_SIDE_NAV_PARENTS.INFORMATION,
    label: "Thông tin nhân sự",
    icon: <IconUserEdit />,
    screenKey: [SCREEN.IP_002, SCREEN.IP_010],
    navSubList: [
      {
        path: pathRoutes.personnelInformation,
        parameter: pathRoutes.personnelInformation,
        subLabel: "Thông tin cá nhân",
        subValue: VALUE_SIDE_NAV_PARENTS.PERSONNEL_INFOMATION,
        screenKey: SCREEN.IP_002,
      },
      // {
      //   path: pathRoutes.workPerformance,
      //   parameter: pathRoutes.workPerformance,
      //   subLabel: "Kết quả thực hiện công việc",
      //   subValue: "WORK_PERFORMANCE",
      //   roleSide: ROLES.ROLE_USER,
      //   screenKey: SCREEN.IP_003,
      // },
      {
        path: `${pathRoutes.declareLeave.base}${pathRoutes.declareLeave.tabs.timeKeeping}`,
        parameter: pathRoutes.declareLeave.parameter,
        subLabel: "Ngày công của tôi",
        subValue: "DECLARE_LEAVE",
        screenKey: SCREEN.IP_015,
      },
      {
        path: pathRoutes.salary.base,
        parameter: pathRoutes.salary.parameter,
        subLabel: "Tra cứu thu nhập",
        subValue: "SALARY",
        screenKey: SCREEN.IP_027,
      },
      // {
      //   path: pathRoutes.regulations,
      //   parameter: pathRoutes.regulations,
      //   subLabel: "Quy định",
      //   subValue: "REGULATIONS",
      //   roleSide: ROLES.ROLE_USER,
      //   screenKey: SCREEN.IP_006,
      // },
      {
        path: pathRoutes.operationProcess,
        parameter: pathRoutes.operationProcess,
        subLabel: "Quá trình công tác, hợp đồng",
        subValue: VALUE_SIDE_NAV_PARENTS.OPERATION_PROCESS,
        screenKey: SCREEN.IP_010,
      },
    ],
  },
  {
    value: VALUE_SIDE_NAV_PARENTS.INTERNAL_CULTURE,
    label: "Văn hóa nội bộ",
    icon: <IconTree />,
    path: pathRoutes.internalCulture,
    parameter: pathRoutes.internalCulture,
    screenKey: SCREEN.IP_007,
    navSubList: [
      {
        path: pathRoutes.internalCulture,
        parameter: pathRoutes.internalCulture,
        subLabel: "Tầm nhìn & sứ mệnh",
        subValue: VALUE_SIDE_NAV_PARENTS.INTERNAL_CULTURE,
        screenKey: SCREEN.IP_007,
      },
      {
        path: pathRoutes.extra.mbsBirthday26,
        parameter: pathRoutes.extra.mbsBirthday26,
        subLabel: "Birthday MBS 2026",
        subValue: VALUE_SIDE_NAV_PARENTS.MBS_2026,
        screenKey: SCREEN.IP_007,
      },
    ],
  },
  {
    value: VALUE_SIDE_NAV_PARENTS.INTERNAL,
    label: "Bản tin nội bộ",
    icon: <IconViewTable />,
    screenKey: [SCREEN.IP_008, SCREEN.IP_020],
    navSubList: [
      {
        path: `${pathRoutes.news.base}${pathRoutes.news.tabs.daily}`,
        parameter: pathRoutes.news.parameter,
        subLabel: "Bản tin",
        subValue: VALUE_SIDE_NAV_PARENTS.INTERNAL_NEWS,
        screenKey: SCREEN.IP_008,
      },
      {
        path: `${pathRoutes.event.base}${pathRoutes.event.tabs.inProgress}`,
        parameter: pathRoutes.event.parameter,
        subLabel: "Sự kiện",
        subValue: VALUE_SIDE_NAV_PARENTS.INTERNAL_EVENT,
        screenKey: SCREEN.IP_020,
      },
      {
        path: `${pathRoutes.birthday.parameter}`,
        parameter: pathRoutes.birthday.parameter,
        subLabel: "Sinh nhật",
        subValue: VALUE_SIDE_NAV_PARENTS.INTERNAL_BIRTHDAY,
        screenKey: SCREEN.IP_028,
      },
    ],
  },
  {
    value: VALUE_SIDE_NAV_PARENTS.DOCUMENTS,
    label: "Thư viện văn bản",
    icon: <IconInbox />,
    screenKey: [SCREEN.IP_012, SCREEN.IP_014],
    navSubList: [
      {
        path: `${pathRoutes.internalDocument.base}${pathRoutes.internalDocument.tabs.general}`,
        parameter: pathRoutes.internalDocument.parameter,
        subLabel: "Văn bản nội bộ",
        subValue: VALUE_SIDE_NAV_PARENTS.INTERNAL_DOCUMENT,
        screenKey: SCREEN.IP_012,
      },
      {
        path: `${pathRoutes.authorizationDocument.base}${pathRoutes.authorizationDocument.tabs.general}${pathRoutes.authorizationDocument.status.active}`,
        parameter: pathRoutes.authorizationDocument.parameter,
        subLabel: "VB phân cấp, ủy quyền",
        subValue: VALUE_SIDE_NAV_PARENTS.AUTHORIZATION_DOCUMENT,
        screenKey: SCREEN.IP_014,
      },
    ],
  },
  {
    value: VALUE_SIDE_NAV_PARENTS.RESEARCH_REPORT,
    label: "Báo cáo nghiên cứu",
    icon: <IconChartLine />,
    path: `${pathRoutes.researchReport.base}${pathRoutes.researchReport.tabs.lastest}`,
    parameter: pathRoutes.researchReport.parameter,
    screenKey: SCREEN.IP_011,
  },
  {
    value: VALUE_SIDE_NAV_PARENTS.RECRUITMENT,
    label: "Tuyển dụng",
    icon: <IconUserPlus />,
    path: pathRoutes.recruitment.base,
    parameter: pathRoutes.recruitment.parameter,
    screenKey: [SCREEN.IP_024],
    navSubList: [
      {
        path: pathRoutes.recruitment.base,
        parameter: pathRoutes.recruitment.parameter,
        subLabel: "Yêu cầu tuyển dụng",
        subValue: VALUE_SIDE_NAV_PARENTS.RECRUITMENT_REQUIREMENT,
        screenKey: SCREEN.IP_024,
      },
      {
        path: `${pathRoutes.evaluation.base}${pathRoutes.evaluation.tabs.filter}`,
        parameter: pathRoutes.evaluation.parameter,
        subLabel: "Đánh giá ứng viên",
        subValue: VALUE_SIDE_NAV_PARENTS.RECRUITMENT_EVALUATION,
        screenKey: SCREEN.IP_025,
      },
    ],
  },

  // {
  //   value: VALUE_SIDE_NAV_PARENTS.WORK_PERFORMANCE,
  //   label: "Kết quả thực hiện công việc",
  //   icon: <IconSuitcase />,
  //   path: pathRoutes.workPerformance,
  //   roleSide: ROLES.ROLE_ADMIN,
  // },
  // {
  //   value: VALUE_SIDE_NAV_PARENTS.DECLARE_LEAVE,
  //   label: "Khai báo nghỉ",
  //   icon: <IconCalendarMinus />,
  //   path: pathRoutes.declareLeave,
  //   roleSide: ROLES.ROLE_ADMIN,
  // },
  // {
  //   value: VALUE_SIDE_NAV_PARENTS.PERSONNEL_FORM,
  //   label: "Mẫu biểu nhân sự",
  //   icon: <IconViewTable />,
  //   path: pathRoutes.personnelForm,
  //   roleSide: ROLES.ROLE_ADMIN,
  // },
  // {
  //   value: VALUE_SIDE_NAV_PARENTS.REGULATIONS,
  //   label: "Quy định",
  //   icon: <IconLayerThree />,
  //   path: pathRoutes.regulations,
  //   roleSide: ROLES.ROLE_ADMIN,
  // },
];

export const logOutNavItem: NavGroupData = {
  value: VALUE_SIDE_NAV_PARENTS.LOG_OUT,
  label: "Đăng xuất",
  icon: <IconLogOut />,
};

export const getTitle = (menu: NavGroupData[], path: string) => {
  const item = menu.find((item) => path.startsWith(item.path));
  return item ? item.label : "IPortal";
};

export const filterNavByScreenKeys = (
  data: NavGroupData[],
  allowedScreenKeys: string[]
): NavGroupData[] => {
  return data
    .map((item) => {
      const isParentVisible = Array.isArray(item.screenKey)
        ? item.screenKey.some((key) => allowedScreenKeys?.includes(key))
        : allowedScreenKeys?.includes(item.screenKey);

      const filteredSubList = item.navSubList?.filter((subItem) =>
        allowedScreenKeys?.includes(subItem.screenKey)
      );

      if (isParentVisible || (filteredSubList && filteredSubList.length > 0)) {
        return {
          ...item,
          navSubList: filteredSubList,
        };
      }
      return null;
    })
    .filter(Boolean) as NavGroupData[];
};
